export default __webpack_public_path__ + "static/media/progress-bar-usage.e6a40f20.svg";